import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { SubmittedToFunderFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveSubmittedToFunderFundingRequests } from "./retrieve-submitted-to-funder-funding-requests";

const initialState: RetrievalState<SubmittedToFunderFundingRequestVM[]> = {
  fetching: "pending",
  data: [],
};

export const retrieveSubmittedToFunderFundingRequestsReducer = createReducer<RetrievalState<SubmittedToFunderFundingRequestVM[]>>(
  initialState,
  builder => {
    builder.addCase(retrieveSubmittedToFunderFundingRequests.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(retrieveSubmittedToFunderFundingRequests.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(retrieveSubmittedToFunderFundingRequests.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
